import { useEffect, useState } from 'react';
import { applyTheme, readStoredTheme, storeTheme } from '@/utils/theme';
import { THEME_STORAGE_KEY, type Theme } from '@/types/theme';

interface UseTheme {
  theme: Theme;
  setTheme: (theme: Theme) => void;
}

export const useTheme = (): UseTheme => {
  const [theme, setThemeState] = useState<Theme>(() =>
    readStoredTheme(THEME_STORAGE_KEY),
  );

  useEffect(() => {
    applyTheme(theme);
    storeTheme(THEME_STORAGE_KEY, theme);
  }, [theme]);

  useEffect(() => {
    if (theme !== 'system') {
      return;
    }

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = () => applyTheme('system');
    mediaQuery.addEventListener('change', handleChange);

    return () => mediaQuery.removeEventListener('change', handleChange);
  }, [theme]);

  return { theme, setTheme: setThemeState };
};
